import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/SecureFilled.tsx
import React from "react";
var SvgSecureFilled, SecureFilled_default;
var init_SecureFilled = __esm({
  "src/icons/SecureFilled.tsx"() {
    SvgSecureFilled = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "m12 1 8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A5.998 5.998 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976L12 1Zm4.452 7.222-4.95 4.949-2.828-2.828-1.414 1.414L11.503 16l6.364-6.364-1.415-1.414Z"
        }
      )
    );
    SecureFilled_default = SvgSecureFilled;
  }
});

export {
  SecureFilled_default,
  init_SecureFilled
};
